export default function OrderDetail() {
  return (
    <div className="min-h-screen pt-32 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-medium">Order Detail</h1>
        <p className="text-stone-600 mt-4">Order details page coming soon</p>
      </div>
    </div>
  );
}
